import { StrutturaUser } from '../models';

/**
 * Contesto and modulo names identifying the ambito of an item, e.g. a CCT event
 */
export interface AmbitoRef {
  contesto?: string | null;
  modulo?: string | null;
}

/**
 * Normalizes a contesto or modulo name for a case and whitespace insensitive comparison.
 * @returns {string} The trimmed upper case name, empty when missing
 */
const normalizeNome = (nome: string | null | undefined): string =>
  nome?.trim().toUpperCase() ?? '';

/**
 * Whether the item belongs to the ambito of the struttura: its modulo is one of the struttura moduli
 * and its contesto is the one of that modulo. Items without contesto and modulo are not restricted.
 * @returns {boolean} True when the item is in the ambito of the struttura
 */
export const isInAmbitoStruttura = (
  ambito: AmbitoRef | null | undefined,
  struttura: StrutturaUser | null | undefined,
): boolean => {
  const contesto = normalizeNome(ambito?.contesto);
  const modulo = normalizeNome(ambito?.modulo);
  if (!contesto && !modulo) return true;
  if (!struttura) return false;

  const hasModulo = (struttura.moduli ?? []).some(
    (m) => normalizeNome(m?.nome) === modulo,
  );
  const hasContestoModulo = (struttura.lavori ?? []).some(
    (lavoro) =>
      normalizeNome(lavoro?.modulo?.nome) === modulo &&
      normalizeNome(lavoro?.modulo?.contesto?.nome) === contesto,
  );
  return hasModulo && hasContestoModulo;
};
